!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("@eg-maps/core")) : "function" == typeof define && define.amd ? define(["@eg-maps/core"], t) : "object" == typeof exports ? exports.egmapsMapbox = t(require("@eg-maps/core")) : e.egmapsMapbox = t(e["@eg-maps/core"]);
}("undefined" != typeof window ? window : global, function (e) {
  return function () {
    "use strict";

    var t = {
        518: function (t) {
          t.exports = e;
        }
      },
      r = {};
    function o(e) {
      var n = r[e];
      if (void 0 !== n) return n.exports;
      var i = r[e] = {
        exports: {}
      };
      return t[e](i, i.exports, o), i.exports;
    }
    o.d = function (e, t) {
      for (var r in t) o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, o.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    o.r(n), o.d(n, {
      MapBox: function () {
        return ae;
      }
    });
    var i = o(518),
      s = 6371008.8,
      a = {
        centimeters: 637100880,
        centimetres: 637100880,
        degrees: 360 / (2 * Math.PI),
        feet: 20902260.511392,
        inches: 39.37 * s,
        kilometers: 6371.0088,
        kilometres: 6371.0088,
        meters: s,
        metres: s,
        miles: 3958.761333810546,
        millimeters: 6371008800,
        millimetres: 6371008800,
        nauticalmiles: s / 1852,
        radians: 1,
        yards: 6967335.223679999
      };
    function l(e, t, r = {}) {
      const o = {
        type: "Feature"
      };
      return (0 === r.id || r.id) && (o.id = r.id), r.bbox && (o.bbox = r.bbox), o.properties = t || {}, o.geometry = e, o;
    }
    function d(e, t, r = {}) {
      if (!e) throw new Error("coordinates is required");
      if (!Array.isArray(e)) throw new Error("coordinates must be an Array");
      if (e.length < 2) throw new Error("coordinates must be at least 2 numbers long");
      if (!m(e[0]) || !m(e[1])) throw new Error("coordinates must contain numbers");
      return l({
        type: "Point",
        coordinates: e
      }, t, r);
    }
    function u(e, t, r = {}) {
      if (e.length < 2) throw new Error("coordinates must be an array of two or more positions");
      return l({
        type: "LineString",
        coordinates: e
      }, t, r);
    }
    function h(e, t = "kilometers") {
      const r = a[t];
      if (!r) throw new Error(t + " units is invalid");
      return e * r;
    }
    function c(e, t = "kilometers") {
      const r = a[t];
      if (!r) throw new Error(t + " units is invalid");
      return e / r;
    }
    function g(e) {
      return 180 * (e % (2 * Math.PI)) / Math.PI;
    }
    function p(e) {
      return e % 360 * Math.PI / 180;
    }
    function m(e) {
      return !isNaN(e) && null !== e && !Array.isArray(e);
    }
    function f(e) {
      if (!e) throw new Error("coord is required");
      if (!Array.isArray(e)) {
        if ("Feature" === e.type && null !== e.geometry && "Point" === e.geometry.type) return [...e.geometry.coordinates];
        if ("Point" === e.type) return [...e.coordinates];
      }
      if (Array.isArray(e) && e.length >= 2 && !Array.isArray(e[0]) && !Array.isArray(e[1])) return [...e];
      throw new Error("coord must be GeoJSON Point or an Array of numbers");
    }
    function y(e, t, r = {}) {
      if (!0 === r.final) return function (e, t) {
        let r = y(t, e);
        return r = (r + 180) % 360, r;
      }(e, t);
      const o = f(e),
        n = f(t),
        i = p(o[0]),
        s = p(n[0]),
        a = p(o[1]),
        l = p(n[1]),
        d = Math.sin(s - i) * Math.cos(l),
        u = Math.cos(a) * Math.sin(l) - Math.sin(a) * Math.cos(l) * Math.cos(s - i);
      return g(Math.atan2(d, u));
    }
    function b(e, t, r, o = {}) {
      const n = f(e),
        i = p(n[0]),
        s = p(n[1]),
        a = p(r),
        l = c(t, o.units),
        u = Math.asin(Math.sin(s) * Math.cos(l) + Math.cos(s) * Math.sin(l) * Math.cos(a));
      return d([g(i + Math.atan2(Math.sin(a) * Math.sin(l) * Math.cos(s), Math.cos(l) - Math.sin(s) * Math.sin(u))), g(u)], o.properties);
    }
    function L(e, t, r = {}) {
      var o = f(e),
        n = f(t),
        i = p(n[1] - o[1]),
        s = p(n[0] - o[0]),
        a = p(o[1]),
        l = p(n[1]),
        d = Math.pow(Math.sin(i / 2), 2) + Math.pow(Math.sin(s / 2), 2) * Math.cos(a) * Math.cos(l);
      return h(2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)), r.units);
    }
    var v = function (e, t, r = {}) {
      var o;
      const n = ("Feature" === (o = e).type ? o.geometry : o).coordinates;
      let i = 0;
      for (let e = 0; e < n.length && !(t >= i && e === n.length - 1); e++) {
        if (i >= t) {
          const o = t - i;
          if (o) {
            const t = y(n[e], n[e - 1]) - 180;
            return b(n[e], o, t, r);
          }
          return d(n[e]);
        }
        i += L(n[e], n[e + 1], r);
      }
      return d(n[n.length - 1]);
    };
    function P(e, t, r) {
      if (null !== e) for (var o, n, i, s, a, l, d, u, h = 0, c = 0, g = e.type, p = "FeatureCollection" === g, m = "Feature" === g, f = p ? e.features.length : 1, y = 0; y < f; y++) {
        a = (u = !!(d = p ? e.features[y].geometry : m ? e.geometry : e) && "GeometryCollection" === d.type) ? d.geometries.length : 1;
        for (var b = 0; b < a; b++) {
          var L = 0,
            v = 0;
          if (null !== (s = u ? d.geometries[b] : d)) {
            l = s.coordinates;
            var M = s.type;
            switch (h = !r || "Polygon" !== M && "MultiPolygon" !== M ? 0 : 1, M) {
              case null:
                break;
              case "Point":
                if (!1 === t(l, c, y, L, v)) return !1;
                c++, L++;
                break;
              case "LineString":
              case "MultiPoint":
                for (o = 0; o < l.length; o++) {
                  if (!1 === t(l[o], c, y, L, v)) return !1;
                  c++, "MultiPoint" === M && L++;
                }
                "LineString" === M && L++;
                break;
              case "Polygon":
              case "MultiLineString":
                for (o = 0; o < l.length; o++) {
                  for (n = 0; n < l[o].length - h; n++) {
                    if (!1 === t(l[o][n], c, y, L, v)) return !1;
                    c++;
                  }
                  "MultiLineString" === M && L++, "Polygon" === M && v++;
                }
                "Polygon" === M && L++;
                break;
              case "MultiPolygon":
                for (o = 0; o < l.length; o++) {
                  for (v = 0, n = 0; n < l[o].length; n++) {
                    for (i = 0; i < l[o][n].length - h; i++) {
                      if (!1 === t(l[o][n][i], c, y, L, v)) return !1;
                      c++;
                    }
                    v++;
                  }
                  L++;
                }
                break;
              case "GeometryCollection":
                for (o = 0; o < s.geometries.length; o++) if (!1 === P(s.geometries[o], t, r)) return !1;
                break;
              default:
                throw new Error("Unknown Geometry Type");
            }
          }
        }
      }
    }
    function M(e, t) {
      var r,
        o,
        n,
        i,
        s,
        a,
        l,
        d,
        u,
        h,
        c = 0,
        g = "FeatureCollection" === e.type,
        p = "Feature" === e.type,
        m = g ? e.features.length : 1;
      for (r = 0; r < m; r++) {
        for (a = g ? e.features[r].geometry : p ? e.geometry : e, d = g ? e.features[r].properties : p ? e.properties : {}, u = g ? e.features[r].bbox : p ? e.bbox : void 0, h = g ? e.features[r].id : p ? e.id : void 0, s = (l = !!a && "GeometryCollection" === a.type) ? a.geometries.length : 1, n = 0; n < s; n++) if (null !== (i = l ? a.geometries[n] : a)) switch (i.type) {
          case "Point":
          case "LineString":
          case "MultiPoint":
          case "Polygon":
          case "MultiLineString":
          case "MultiPolygon":
            if (!1 === t(i, c, d, u, h)) return !1;
            break;
          case "GeometryCollection":
            for (o = 0; o < i.geometries.length; o++) if (!1 === t(i.geometries[o], c, d, u, h)) return !1;
            break;
          default:
            throw new Error("Unknown Geometry Type");
        } else if (!1 === t(null, c, d, u, h)) return !1;
        c++;
      }
    }
    function _(e, t) {
      M(e, function (e, r, o, n, i) {
        var s,
          a = null === e ? null : e.type;
        switch (a) {
          case null:
          case "Point":
          case "LineString":
          case "Polygon":
            return !1 !== t(l(e, o, {
              bbox: n,
              id: i
            }), r, 0) && void 0;
        }
        switch (a) {
          case "MultiPoint":
            s = "Point";
            break;
          case "MultiLineString":
            s = "LineString";
            break;
          case "MultiPolygon":
            s = "Polygon";
        }
        for (var d = 0; d < e.coordinates.length; d++) {
          var u = e.coordinates[d];
          if (!1 === t(l({
            type: s,
            coordinates: u
          }, o), r, d)) return !1;
        }
      });
    }
    function w(e, t, r) {
      var o = r,
        n = !1;
      return function (e, t) {
        _(e, function (e, r, o) {
          var n = 0;
          if (e.geometry) {
            var i = e.geometry.type;
            if ("Point" !== i && "MultiPoint" !== i) {
              var s,
                a = 0,
                l = 0,
                d = 0;
              return !1 !== P(e, function (i, h, c, g, p) {
                if (void 0 === s || r > a || g > l || p > d) return s = i, a = r, l = g, d = p, void (n = 0);
                var m = u([s, i], e.properties);
                if (!1 === t(m, r, o, p, n)) return !1;
                n++, s = i;
              }) && void 0;
            }
          }
        });
      }(e, function (e, i, s, a, l) {
        o = !1 === n && void 0 === r ? e : t(o, e, i, s, a, l), n = !0;
      }), o;
    }
    var x = function (e, t = {}) {
      return w(e, (e, r) => {
        const o = r.geometry.coordinates;
        return e + L(o[0], o[1], t);
      }, 0);
    };
    function C(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, o);
      }
      return r;
    }
    function k(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? C(Object(r), !0).forEach(function (t) {
          E(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : C(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function E(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var o = r.call(e, t || "default");
            if ("object" != typeof o) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    const {
        firstDefinedValue: S,
        firstDefinedValueAndKey: F,
        firstDefinedKey: T,
        removeDuplicates: O,
        roundLatOrLng: A,
        roundLatLng: B,
        isArray: D,
        getPaddedZoomAndCenter: N,
        roundZoom: j
      } = i.Utils,
      {
        createPinMarker: z,
        createTextMarker: Z,
        createClusterMarker: I,
        createObfuscatedMarker: K,
        events: V,
        finalizeMarkerCreation: R,
        cleanMarkerListeners: W,
        setMarkerZIndex: H,
        registerCompListeners: G
      } = i.MarkerUtils,
      {
        computeZoomFromBBox: q,
        areBoundsCrossingDateLine: U,
        areCoordinatesCrossingDateLine: $
      } = i.Geo,
      J = "flying",
      Q = {
        height: 512,
        width: 512
      },
      X = 200,
      Y = "fill-color",
      ee = "fill-opacity",
      te = "line-color",
      re = "line-width",
      oe = "line-opacity",
      ne = "visiblePolygons",
      ie = "obfuscatedPolygons",
      se = {
        scaleControl: e => new mapboxgl.ScaleControl(e),
        navControl: e => new mapboxgl.NavigationControl(e),
        geoLocateControl: e => new mapboxgl.GeolocateControl(e),
        fullscreenControl: e => new mapboxgl.FullscreenControl(e)
      };
    class ae extends i.BaseMap {
      constructor(e, t, r, o) {
        super(e, t, r, o), this.TilesLoader = i.TilesLoader, this.logger = e.logger("MapBox"), this.logger.debug("MapBox constructor"), this.mapConfig = {
          keyboard: !1
        }, this.additionalConfig = this.settings.mapbox.mapboxAddConf, this.rtlTextPlugin = this.settings.mapbox.rtlTextPlugin, this.additionalConfig && Object.assign(this.mapConfig, this.additionalConfig);
      }
      deleteMarker(e) {
        const {
          marker: t
        } = e;
        t && (t.remove(), t.debug && t.debug.remove(), this._clearObfuscateArea(e), W(t), delete e.marker);
      }
      init(e, t) {
        this.mapConfig.container = this.node;
        const r = this.configHelper.mapboxAccessToken();
        if (r) mapboxgl.accessToken = r;else if (!mapboxgl.accessToken) throw new Error("No mapbox access token set ! Mapbox cannot work properly !");
        const {
          zoom: o,
          center: n
        } = this._zoomAndCenterFromViewport(e, t) || {};
        o && n && (this.mapConfig.zoom = o - 1, this.mapConfig.center = [n[1], n[0]]), this.realmap = new mapboxgl.Map(this.mapConfig), Object.keys(se).forEach(e => this._addControl(e, se[e])), this.mapNavFocusElement = this.realmap.getCanvas(), this._handleMapFocus(), this._registerMapListeners(), this.visiblePolygons = [], this.obfuscatedPolygons = [];
        const i = [];
        i.push(this._initializeTilesLoader());
        const s = this._initializeRoutesSourcesAndLayers.bind(this),
          a = this._initializePolygonsSourcesAndLayers.bind(this, ne, this.visiblePolygons),
          l = this._initializePolygonsSourcesAndLayers.bind(this, ie, this.obfuscatedPolygons),
          d = new Promise(e => {
            this.realmap.on("load", () => {
              s(), a(), l(), e();
            });
          });
        return this.configHelper.readParam("map,mapInitWaitForTiles") && i.push(d), this.popup = this._createPopup(), Promise.all(i);
      }
      _addControl(e, t) {
        const r = this.configHelper.readParam(`mapbox,${e}`);
        if (r.ctrlEnabled) {
          const e = t(r.ctrlOptions),
            o = r.ctrlPosition;
          this.realmap.addControl(e, o);
        }
      }
      registerListenerOnMapFocusElement(e, t) {
        this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, e, t));
      }
      _handleMapFocus() {
        if (this.keyboardFeatures && this.mapNavFocusElement) {
          const e = () => this.keyboardFeatures.refreshKeyboardNavIconVisibility();
          this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, V.focus, e));
          const t = () => this.keyboardFeatures.refreshKeyboardNavIconVisibility(!1);
          this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, V.focusOut, t));
        }
      }
      _initializeTilesLoader() {
        return new Promise(e => {
          this.tilesLoader = new this.TilesLoader(this.settings, this.createTileFeature.bind(this), this.removeTileFeature.bind(this), this._updateViewport.bind(this), this.handleTilesLoaded.bind(this), this.handleTilesContentLoaded.bind(this), 1), this.realmap.on("data", e => {
            if (e && e.coord && "source" === e.dataType && e.coord.canonical) {
              const t = e.coord.canonical;
              this.tilesLoader.loadTile(t.x, t.y, t.z, 1);
            }
          }), e();
        });
      }
      resetRouteStyle() {
        Object.keys(this.routesSources).forEach(e => {
          this.realmap.removeLayer(this.routesSources[e].id), this.realmap.addLayer(this._createRouteLayer(e));
        });
      }
      _createRouteLayer(e) {
        const t = this.settings.routeLineStyleByDistanceMode[e],
          r = {
            id: `layer-${e}`,
            type: "line",
            source: e,
            data: {
              type: "FeatureCollection",
              features: []
            },
            paint: {
              "line-color": t.color,
              "line-opacity": t.opacity,
              "line-width": t.width
            }
          };
        switch (t.lineStyle) {
          case "dash":
            r.paint["line-dasharray"] = [2, 2];
            break;
          case "dot":
            r.paint["line-dasharray"] = [1, 1];
        }
        return this.routesSources[e] = r, r;
      }
      _initializePolygonsSourcesAndLayers(e, t) {
        this.realmap.addSource(e, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: t
          }
        }), this.realmap.addLayer({
          id: `${e}Fill`,
          type: "fill",
          source: e,
          layout: {},
          paint: {
            [Y]: ["get", Y],
            [ee]: ["get", ee]
          }
        }), this.realmap.addLayer({
          id: `${e}Stroke`,
          type: "line",
          source: e,
          layout: {},
          paint: {
            [te]: ["get", te],
            [re]: ["get", re],
            [oe]: ["get", oe]
          }
        });
      }
      _initializeRoutesSourcesAndLayers() {
        this.routesSources = {}, ["cycling", "driving", "walking", J].forEach(e => {
          this.realmap.addSource(e, {
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features: []
            }
          }), this.realmap.addLayer(this._createRouteLayer(e));
        });
      }
      _handleMapClick(e) {
        const {
            lngLat: {
              lat: t,
              lng: r
            },
            point: {
              x: o,
              y: n
            }
          } = e,
          i = {
            position: {
              x: o,
              y: n
            },
            latLng: {
              lat: t,
              lng: r
            }
          };
        this.handleMapClick(i);
      }
      _registerMapListeners() {
        this.registeredEvents = {}, this.listenersToDeregister.push(...this._registerKeyboardListeners()), this.listenersToDeregister.push(this._registerIdleListener()), this.listenersToDeregister.push(this._registerZoomListener()), this.listenersToDeregister.push(...this._registerListenerForBoundsChanged("dragend", "drag")), this.listenersToDeregister.push(...this._registerListenerForBoundsChanged("pitchend", "pitch")), this.listenersToDeregister.push(...this._registerListenerForBoundsChanged("rotatend", "rotate")), this.listenersToDeregister.push(...this._registerListenerForBoundsChanged("touchend", "touch")), this.listenersToDeregister.push(this._registerMapListener("dragstart", this.handleDragStart.bind(this))), this.listenersToDeregister.push(this._registerMapListener("style.load", this.setLocale.bind(this))), this.listenersToDeregister.push(this._registerMapListener("click", this._handleMapClick.bind(this))), this.listenersToDeregister.push(this._registerTilesLoadedListener());
      }
      _registerTilesLoadedListener() {
        this.tilesLoadedCount = 0;
        return this._registerMapListener("sourcedata", () => {
          this.tilesLoadedCount++;
          const e = (t, r) => () => {
            t > 0 && t === r.tilesLoadedCount ? (r.tilesLoadedCount = 0, r.handleTilesLoaded("mapProvider", "map")) : r.tilesLoadedCount > 0 && setTimeout(e(r.tilesLoadedCount, r), 500);
          };
          setTimeout(e(this.tilesLoadedCount, this), 500);
        });
      }
      _registerKeyboardListeners() {
        const e = {
            duration: X
          },
          t = this.realmap.zoomIn.bind(this.realmap),
          r = this.realmap.zoomOut.bind(this.realmap);
        this.keyboardListeners = new i.KeyboardListeners(t => this.realmap.panBy(t, e), t, r);
        const o = this.handleBoundsChanged.bind(this);
        return [this.addEventListener(this.mapNavFocusElement, V.keyDown, this.keyboardListeners.keyDownListenerCallback), this.addEventListener(this.mapNavFocusElement, V.keyUp, this.keyboardListeners.keyUpListenerCallback), this.addEventListener(this.mapNavFocusElement, V.keyPress, this.keyboardListeners.keyPressListenerCallback), this._registerMapListener("idle", () => {
          O(this.keyboardListeners.extractKeyboardEvent("center_changed")).forEach(o);
        })];
      }
      _registerZoomListener() {
        this.lastZoomValueChecked = this.getZoom();
        const e = this.handleBoundsChanged.bind(this),
          t = this.getZoom.bind(this);
        return this._registerMapListener("zoomend", () => {
          const r = t(),
            o = r > this.lastZoomValueChecked;
          this.lastZoomValueChecked = r;
          const n = this.keyboardListeners.extractKeyboardEvent("zoom_changed");
          n.length > 0 ? O(n).forEach(e) : e(o ? "zoomIn" : "zoomOut");
        });
      }
      _registerMapListener(e, t, r) {
        return r ? (this.realmap.on(e, r, t), () => this.realmap.off(e, r, t)) : (this.realmap.on(e, t), () => this.realmap.off(e, t));
      }
      _registerListenerForBoundsChanged(e, t) {
        const r = this.handleBoundsChanged.bind(this);
        this.registeredEvents[e] = [];
        return [this._registerMapListener(e, r => {
          r.originalEvent && this.registeredEvents[e].push(t);
        }), this._registerMapListener("idle", () => O(this.registeredEvents[e].splice(0)).forEach(r))];
      }
      _registerIdleListener() {
        return this._registerMapListener("idle", () => this.eventsManager.pushEvent(i.EventTypes.idle));
      }
      unbindAll() {
        this.listenersToDeregister.forEach(e => e()), this.realmap && this.realmap.remove(), super.unbindAll();
      }
      addEventListener(e, t, r) {
        return arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? e.addEventListenerOnce(t, r) : e.addEventListener(t, r), () => e.removeEventListener(t, r);
      }
      centerAndZoomMap(e, t, r) {
        let [o, n] = e ? B(e) : [],
          i = t;
        const s = {};
        if (void 0 !== o && void 0 !== n && void 0 !== i && void 0 !== r) {
          const s = this._parseClientPadding(r),
            {
              zoom: a,
              center: l
            } = this._getPaddedZoomAndCenterForCenterAndZoom(e, t, s) || {};
          void 0 !== a && void 0 !== l && ([o, n] = l, i = a - 1);
        }
        if (void 0 !== o && void 0 !== n) {
          const e = this.realmap.getCenter(),
            [t, r] = B([e.lat, e.lng]);
          t === o && r === n || (s.center = new mapboxgl.LngLat(n, o));
        }
        return i && this.getZoom() !== i && (s.zoom = i), !(!s.center && !s.zoom) && (this.boundChangedDisabled = !0, this.realmap.once("moveend", () => {
          this._updateViewport();
        }), this.realmap.easeTo(k({
          duration: X
        }, s)), !0);
      }
      asNativeBounds(e, t) {
        let r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        return new mapboxgl.LngLatBounds(new mapboxgl.LngLat(A(e[1], void 0, r), A(e[0], void 0, !1)), new mapboxgl.LngLat(A(t[1], void 0, r), A(t[0], void 0, !1)));
      }
      isFeatureInRealBound(e, t) {
        const r = e.contains([t.latLng[1], t.latLng[0]]);
        if (!r) {
          if (e.getNorthEast().lng > 180) return e.contains([t.latLng[1] + 360, t.latLng[0]]);
          if (e.getSouthWest().lng < -180) return e.contains([t.latLng[1] - 360, t.latLng[0]]);
        }
        return r;
      }
      getCenter() {
        const e = this.realmap.getCenter();
        return [e.lat, e.lng];
      }
      getRectOfMarker(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        const {
            clientWidth: r,
            clientHeight: o
          } = this.getMarkerElement(e),
          n = this.realmap.project(e.marker.getLngLat());
        return i.HtmlUtils.getRect(n, r + 2 * t, o + 2 * t);
      }
      getZoom() {
        return j(this.realmap.getZoom());
      }
      asBounds(e) {
        if (e) {
          const t = e.getSouthWest(),
            r = e.getNorthEast(),
            o = this.getCenter();
          return {
            sw: [A(t.lat), A(t.lng)],
            ne: [A(r.lat), A(r.lng)],
            center: o
          };
        }
      }
      containerBounds(e) {
        if (this.realmap) {
          const t = this.realmap.unproject([e.offsetLeft - e.offsetWidth / 2, e.offsetTop + e.offsetHeight / 2]),
            r = this.realmap.unproject([e.offsetLeft + e.offsetWidth / 2, e.offsetTop - e.offsetHeight / 2]);
          return {
            sw: [A(t.lat), A(t.lng)],
            ne: [A(r.lat), A(r.lng)],
            center: [A(t.lat + (t.lat - r.lat) / 2), A(r.lng + (r.lng - t.lng) / 2)]
          };
        }
      }
      computeNativeBoundsFromLatLongs(e) {
        if ((null == e ? void 0 : e.length) > 0) {
          const t = this._computeNativeBoundsFromLatLongsAux(e);
          if ($(e)) {
            const r = this._computeNativeBoundsFromLatLongsAux(e.filter(e => {
                var t;
                return (null !== (t = e.lng) && void 0 !== t ? t : e[1]) < 0;
              })),
              o = this._computeNativeBoundsFromLatLongsAux(e.filter(e => {
                var t;
                return (null !== (t = e.lng) && void 0 !== t ? t : e[1]) >= 0;
              }));
            return this.asNativeBounds(B([t.getSouthWest().lat, o.getSouthWest().lng]), B([r.getNorthEast().lat, r.getNorthEast().lng]));
          }
          return t;
        }
      }
      _computeNativeBoundsFromLatLongsAux(e) {
        let t = new mapboxgl.LngLatBounds();
        return e.forEach(e => {
          const [r, o] = B(e);
          t = t.extend(new mapboxgl.LngLat(o, r));
        }), t;
      }
      _zoomAndCenterFromViewport(e, t) {
        if (e) {
          const {
              center: r,
              zoom: o,
              sw: n,
              ne: i,
              coordinates: s,
              useBoundsComputation: a,
              options: l
            } = e,
            d = this._parseClientPadding(t);
          if (r && o) return this._getPaddedZoomAndCenterForCenterAndZoom(r, o, d);
          if (n && i) {
            const e = B(n),
              t = B(i);
            return this._getPaddedZoomAndCenterForBounds(e, t, !1, d);
          }
          if (s && a) {
            const e = this._computeNativeBounds(s, a, l),
              {
                zoom: t,
                center: r
              } = this._computeZoomAndCenterFromMapboxBounds(e, !1, d) || {};
            if (void 0 !== t && void 0 !== r) return N(t + 1, r, d);
          } else if (D(e) && e.length > 0) return this._getPaddedZoomAndCenterFromLatLongs(e, !0, d);
        }
      }
      _getPaddedZoomAndCenterForCenterAndZoom(e, t, r) {
        return N(t + 1, e, r);
      }
      _getPaddedZoomAndCenterForBounds(e, t, r, o) {
        let n = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e[1], e[0]), new mapboxgl.LngLat(t[1], t[0]));
        const {
          zoom: i,
          center: s
        } = this._computeZoomAndCenterFromMapboxBounds(n, r, o) || {};
        if (void 0 !== i && void 0 !== s) return N(i + 1, s, o);
      }
      _getPaddedZoomAndCenterFromLatLongs(e, t, r) {
        const {
          zoom: o,
          center: n
        } = this._computeZoomAndCenterFromMapboxBounds(this.computeNativeBoundsFromLatLongs(this.boundsComputation.computeBoundingBox(e)), t, r) || {};
        if (void 0 !== o && void 0 !== n) return N(o + 1, n, r);
      }
      _computeZoomAndCenterFromMapboxBounds(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          r = arguments.length > 2 ? arguments[2] : void 0,
          o = e;
        this._boundsForOneCoordinate(o) && (o = new mapboxgl.LngLatBounds(o.getSouthWest(), o.getNorthEast()), o = this._extendsOneCoordinateBounds(o)), o = this._fixDatelineBoundsForMapboxInternalMethods(o);
        const n = q(this.node, o.getSouthWest().lat, o.getSouthWest().lng, o.getNorthEast().lat, o.getNorthEast().lng, {
          zoomMax: 22,
          padding: t ? this.configHelper.readParam("mapbox,padding") : 0,
          worldDimensions: Q,
          parsedClientPadding: r
        });
        if (isFinite(n)) return {
          zoom: n,
          center: B([o.getCenter().lat, o.getCenter().lng])
        };
      }
      _extendsOneCoordinateBounds(e) {
        let t = new mapboxgl.LngLat(e.getNorthEast().lng + .01, e.getNorthEast().lat + .01),
          r = new mapboxgl.LngLat(e.getNorthEast().lng - .01, e.getNorthEast().lat - .01);
        return e.extend(t).extend(r);
      }
      _boundsForOneCoordinate(e) {
        return e.getNorthEast().lat === e.getSouthWest().lat && e.getNorthEast().lng === e.getSouthWest().lng;
      }
      _fixDatelineBoundsForMapboxInternalMethods(e) {
        const t = e.getSouthWest(),
          r = e.getNorthEast();
        return U(t, r) ? this.asNativeBounds([t.lat, t.lng], [r.lat, r.lng + 360], !1) : e;
      }
      fitLatLongs(e) {
        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          r = arguments.length > 2 ? arguments[2] : void 0;
        if (this.realmap) {
          this.boundChangedDisabled = !0;
          const o = this._parseClientPadding(r),
            {
              zoom: n,
              center: i
            } = this._getPaddedZoomAndCenterFromLatLongs(e, t, o) || {};
          if (void 0 !== n && void 0 !== i) {
            const e = {
              center: new mapboxgl.LngLat(i[1], i[0]),
              zoom: n - 1
            };
            return new Promise(t => {
              this.realmap.once("moveend", () => {
                this._updateViewport().then(e => t(this.asBounds(e)));
              }), this.realmap.easeTo(k({
                duration: X
              }, e));
            });
          }
          return Promise.resolve(this.getBounds());
        }
        return Promise.reject("map is not ready");
      }
      refresh() {
        this.realmap.resize(), super.refresh();
      }
      nativeBounds() {
        if (this.realmap) return this.realmap.getBounds();
      }
      getTileDim() {
        return {
          width: Q.width,
          height: Q.height
        };
      }
      fitBounds(e, t) {
        let r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          o = arguments.length > 3 ? arguments[3] : void 0;
        if (this.realmap) {
          this.boundChangedDisabled = !0;
          const n = this._parseClientPadding(o),
            i = B(e),
            s = B(t),
            {
              zoom: a,
              center: l
            } = this._getPaddedZoomAndCenterForBounds(i, s, r, n) || {};
          if (void 0 !== a && void 0 !== l) {
            const e = this.getZoom(),
              [t, r] = this.getCenter();
            if (t !== l[0] || r !== l[1] || e !== a - 1) {
              const e = {
                center: new mapboxgl.LngLat(l[1], l[0]),
                zoom: a - 1
              };
              return new Promise(t => {
                this.realmap.once("moveend", () => {
                  this._updateViewport().then(e => t(this.asBounds(e)));
                }), this.realmap.easeTo(k({
                  duration: X
                }, e));
              });
            }
            this.boundChangedDisabled = !1;
          }
          return Promise.resolve(this.getBounds());
        }
        return Promise.reject("map is not ready");
      }
      getMarkerElement(e) {
        var t;
        return null === (t = e.marker) || void 0 === t ? void 0 : t.getElement();
      }
      moveMarkerPosition(e, t) {
        const r = this.realmap.project(e.marker.getLngLat());
        r.x += t.x, r.y += t.y;
        const o = this.realmap.unproject(r);
        e.marker.setLngLat(o);
      }
      updatePopupPositionOnLayer() {
        const {
          feature: e
        } = this.popup || {};
        if (e && e.defined) {
          let t, r;
          switch (S(this.settings.popupPositions[e.type], e.hashKeys)) {
            case "above":
            default:
              t = 0, r = -24;
              break;
            case "below":
              t = 0, r = 5 + this.popup.getElement().offsetHeight;
          }
          this.popup.setOffset([t, r]), this.popup.setLngLat([this.popup.feature.latLng[1], this.popup.feature.latLng[0]]);
        }
      }
      _updateViewport(e) {
        return this.realmap ? super._updateViewport(e).then(e => (this._updateMarkerPositionFromCollision(), e)) : Promise.resolve(e);
      }
      ensurePopupVisibility() {
        const {
            popup: {
              feature: e,
              visibleElement: {
                offsetWidth: t,
                offsetHeight: r
              }
            },
            node: {
              offsetWidth: o,
              offsetHeight: n
            }
          } = this,
          i = S(this.configHelper.popupVisibilityPaddings()[e.type], e.hashKeys),
          s = null == i ? void 0 : i.x,
          a = null == i ? void 0 : i.y,
          l = "below" === S(this.settings.popupPositions[e.type], e.hashKeys),
          d = l ? 1 : -1,
          u = this.getRectOfMarker(e).height,
          h = this.realmap.project(e.marker.getLngLat());
        let c = {
          x: h.x - t / 2,
          y: h.y + u * d + r * d
        };
        const [g, p] = this._calculatePopupVisibilityOffsetValues(c, s, a, o, n, t, r, l);
        if (0 !== g || 0 !== p) {
          const e = this.realmap.project(this.realmap.getCenter()),
            t = this.realmap.unproject([e.x + g, e.y + p]);
          this.realmap.easeTo(t, {
            duration: X
          });
        }
      }
      _createPopup() {
        const e = this._createGenericPopup(void 0),
          t = new mapboxgl.Marker({
            element: e,
            anchor: "bottom"
          }).setLngLat([0, 0]).addTo(this.realmap);
        return i.HtmlUtils.setDisplayNone(e), t.content = e.content, t.cssElement = e, t.visibleElement = e, t.zIndexElement = e, t.listening = e, W(t), t.clean = G(t.listening, !1, () => t.feature, this.settings, this.getEventManagementMethods()), H(t, this.settings.maxZIndex + 1), t;
      }
      _clearObfuscateArea(e) {
        const t = this.asKey(e);
        this.obfuscatedPolygons.findIndex(e => e.feature_id == t) >= 0 && (this.obfuscatedPolygons = this.obfuscatedPolygons.filter(e => e.feature_id !== t), this._updateObfuscatedPolygonsSource());
      }
      _newFixMarkerToUse() {
        var e = () => super._newFixMarkerToUse,
          t = this;
        return function () {
          e().call(t)(...arguments), t._updateObfuscatedPolygonsSource();
        };
      }
      _updateObfuscatedPolygonsSource() {
        this._updatePolygonsSource(ie, this.obfuscatedPolygons);
      }
      _updateVisiblePolygonsSource() {
        this._updatePolygonsSource(ne, this.visiblePolygons);
      }
      _updatePolygonsSource(e, t) {
        var r;
        if ("function" == typeof (null === (r = this.realmap) || void 0 === r ? void 0 : r.getSource)) {
          var o;
          const r = null === (o = this.realmap) || void 0 === o ? void 0 : o.getSource(e);
          null == r || r.setData({
            type: "FeatureCollection",
            features: t
          });
        }
      }
      hasObfuscatedAreaStyleChanged(e) {
        let t = this.obfuscatedPolygons.findIndex(t => t.feature_id === this.asKey(e));
        if (t >= 0) {
          const r = T(this.settings.obfuscateStyle[e.type], e.hashKeys);
          return this.obfuscatedPolygons[t].properties.styleKey !== r;
        }
        return !1;
      }
      _getPolygonStyle(e) {
        return {
          [Y]: e.fill.color,
          [ee]: e.fill.opacity,
          [te]: e.line.color,
          [re]: e.line.weight,
          [oe]: e.line.opacity
        };
      }
      _createClickableObfuscatedPolygon(e, t) {
        return this._createObfuscatedPolygon(e, t, !0);
      }
      _createNonClickableObfuscatedPolygon(e, t) {
        return this._createObfuscatedPolygon(e, t, !1);
      }
      _createObfuscatedPolygon(e, t, r) {
        const o = this.asKey(t),
          n = this.getCirclePolygonData(t),
          {
            key: i,
            value: s
          } = F(this.settings.obfuscateStyle[t.type], t.hashKeys);
        let a = this.obfuscatedPolygons.findIndex(e => e.feature_id == o);
        if (a < 0) {
          const e = {
            feature_id: o,
            type: "Feature",
            properties: k({
              styleKey: i
            }, this._getPolygonStyle(s)),
            geometry: {
              type: "Polygon",
              coordinates: [n.map(e => [e.lng, e.lat])]
            }
          };
          this.obfuscatedPolygons.push(e);
        } else this.obfuscatedPolygons[a].properties = this._getPolygonStyle(s), this._updateObfuscatedPolygonsSource();
      }
      _createDebugMarker(e) {
        return this.settings.debugMarkersPosition ? {
          debug: new mapboxgl.Marker().setLngLat([e.latLng[1], e.latLng[0]]).addTo(this.realmap),
          style: "opacity: 0.5"
        } : {};
      }
      stopPropagation(e) {
        e.stopPropagation();
      }
      getEventManagementMethods() {
        return {
          addEventListener: this.addEventListener.bind(this),
          stopPropagation: this.stopPropagation.bind(this),
          handleClick: this.handleClick.bind(this),
          handleMouseOver: this.handleMouseOver.bind(this),
          handleMouseOut: this.handleMouseOut.bind(this),
          handleKeyPress: this.handleKeyPress.bind(this)
        };
      }
      createPinMarker(e, t, r) {
        return this._createPinMarker(e, t, r);
      }
      createPinObfuscatedMarker(e, t, r) {
        return this._createPinMarker(e, t, r, this._createObfuscatedPolygon.bind(this));
      }
      _createPinMarker(e, t, r, o) {
        const {
            feature: n
          } = e,
          {
            debug: i,
            style: s
          } = this._createDebugMarker(n),
          a = this.uniqId(`marker-${this.asKey(n)}`),
          l = z(a, e, void 0, t, r, s, this.settings, o);
        l.debug = i;
        const d = new mapboxgl.Marker({
          element: l.content,
          anchor: "bottom"
        }).setLngLat([n.latLng[1], n.latLng[0]]).addTo(this.realmap);
        return R(d, l, e, this.settings, this.getEventManagementMethods(), this._switchAriaLabel), d;
      }
      createTextMarker(e, t, r) {
        return this._createTextMarker(e, t, r);
      }
      createPriceObfuscatedMarker(e, t) {
        return this._createTextMarker(e, t, "price", this._createNonClickableObfuscatedPolygon.bind(this));
      }
      _createTextMarker(e, t, r, o) {
        const {
            feature: n
          } = e,
          {
            debug: i,
            style: s
          } = this._createDebugMarker(n),
          a = this.uniqId(`marker-${this.asKey(n)}`),
          l = Z(a, e, void 0, t, r, s, this.settings, o);
        l.debug = i;
        const d = new mapboxgl.Marker({
          element: l.content,
          anchor: "bottom"
        }).setLngLat([n.latLng[1], n.latLng[0]]).addTo(this.realmap);
        return R(d, l, e, this.settings, this.getEventManagementMethods(), this._switchAriaLabel), d;
      }
      createClusterMarker(e) {
        const {
            debug: t,
            style: r
          } = this._createDebugMarker(e),
          {
            featureType: o,
            qualifier: n
          } = e,
          i = this.uniqId(`marker-${o}-cluster-${e.id}`),
          s = I(i, void 0, e, o, n, r);
        s.debug = t;
        const a = new mapboxgl.Marker({
            element: s.content
          }).setLngLat([e.latLng[1], e.latLng[0]]).addTo(this.realmap),
          l = S(this.settings.zIndexes[e.type], e.hashKeys),
          d = {
            default: e.text,
            onSelect: e.text
          };
        return R(a, s, {
          feature: e,
          zIndex: l,
          ariaLabels: d
        }, this.settings, this.getEventManagementMethods(), this._switchAriaLabel), a;
      }
      createObfuscatedMarker(e) {
        const {
            feature: t
          } = e,
          {
            debug: r,
            style: o
          } = this._createDebugMarker(t),
          n = this.uniqId(`marker-${this.asKey(t)}`),
          i = K(n, e, void 0, o, this.settings, this._createClickableObfuscatedPolygon.bind(this));
        i.debug = r;
        const s = new mapboxgl.Marker({
          element: i.content
        }).setLngLat([t.latLng[1], t.latLng[0]]).addTo(this.realmap);
        return R(s, i, e, this.settings, this.getEventManagementMethods(), this._switchAriaLabel), s;
      }
      setLocale() {
        if (this.settings.locale) {
          const e = this.settings.locale.substring(0, 2);
          "unavailable" === mapboxgl.getRTLTextPluginStatus() && mapboxgl.setRTLTextPlugin(this.rtlTextPlugin, null, !0);
          const t = this.realmap.getStyle().layers.filter(e => /-label/.test(e.id));
          for (let r of t) this.realmap.setLayoutProperty(r.id, "text-field", ["coalesce", ["get", "name_" + e], ["get", "name"]]);
        }
      }
      _genGeodesicRoute(e, t) {
        try {
          const r = {
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: [e, t]
              }
            },
            o = x(r),
            n = [],
            i = 500;
          for (let e = 0; e < o; e += o / i) {
            const t = v(r, e);
            n.push(t.geometry.coordinates);
          }
          return n.length > 1 && n[0][0] < 0 && n[1][0] > 0 && (n[0][0] += 360), n;
        } catch (e) {
          this.logger.error("failed to generate geodesic line. use straight line", e);
        }
      }
      addRouteOnMap(e, t) {
        return new Promise(r => {
          const o = this.routesSources[e.mode];
          if (o) {
            const {
              path: r
            } = t.route;
            let n = r.map(e => {
              let {
                lat: t,
                lng: r
              } = e;
              return [r, t];
            });
            e.mode === J && 2 == n.length && (n = this._genGeodesicRoute(n[0], n[1]) || n), o.data.features.push({
              id: e.id,
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: n
              }
            }), this.realmap.getSource(e.mode).setData(o.data);
          }
          r(e);
        });
      }
      removeRouteOnMap(e) {
        return new Promise((t, r) => {
          const o = this.routesSources[e.mode];
          if (o) {
            const r = o.data.features.findIndex(t => t.id === e.id);
            r >= 0 && (o.data.features.splice(r, 1), this.realmap.getSource(e.mode).setData(o.data)), t();
          } else r(new Error(`can't find source for ${e.mode}`));
        });
      }
      updateMapProviderConfig() {}
      addPolygonsOnMap(e) {
        const t = e.map(e => {
          let {
            polygonDisplayed: t,
            style: r
          } = e;
          const {
              id: o,
              type: n,
              polygon: i
            } = t,
            s = {
              feature_id: this.asKey({
                id: o,
                type: n
              }),
              type: "Feature",
              properties: this._getPolygonStyle(r),
              geometry: i
            };
          return this.visiblePolygons.push(s), {
            id: o,
            type: n
          };
        });
        return this._updateVisiblePolygonsSource(), Promise.resolve(t);
      }
      removePolygonsOnMap(e) {
        const t = e.map(e => {
          const t = this.asKey(e),
            r = this.visiblePolygons.findIndex(e => e.feature_id == t);
          if (r >= 0) return this.visiblePolygons.splice(r, 1), e;
        }).filter(e => void 0 !== e);
        return e.length > 0 && this._updateVisiblePolygonsSource(), Promise.resolve(t);
      }
      forceMapModeView() {}
    }
    return ("undefined" != typeof window ? window : o.g).egmapsMapbox = n, {};
  }();
});